// eslint-disable-next-line import/prefer-default-export
export { default as SellerLanding } from './landing-page';
